import React, { useState } from 'react';
import { PlansSlide } from '../components/Onboarding';
import { Lock } from '../components/icons';
import { getSubscriptionPortal } from '../api/client';

export default function PaywallPage({ onReplayOnboarding }) {
  const [portalLoading, setPortalLoading] = useState(false);

  async function handlePortal() {
    if (portalLoading) return;
    setPortalLoading(true);
    try {
      const data = await getSubscriptionPortal();
      if (data && data.url) {
        if (window.Telegram?.WebApp?.openLink) {
          window.Telegram.WebApp.openLink(data.url);
        } else {
          window.open(data.url, '_blank');
        }
      } else {
        const tg = window.Telegram?.WebApp;
        const msg = 'Не удалось открыть обновление оплаты. Напишите менеджеру — мы поможем возобновить доступ.';
        if (tg?.showAlert) {
          tg.showAlert(msg);
        } else {
          alert(msg);
        }
      }
    } catch (_err) {
      const tg = window.Telegram?.WebApp;
      const msg = 'Не удалось открыть обновление оплаты. Напишите менеджеру — мы поможем возобновить доступ.';
      if (tg?.showAlert) {
        tg.showAlert(msg);
      } else {
        alert(msg);
      }
    } finally {
      setPortalLoading(false);
    }
  }

  return (
    <div style={{
      minHeight: '100dvh', background: 'var(--bg-primary)',
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      padding: '32px 24px 40px', textAlign: 'center', overflowY: 'auto',
    }}>
      {/* Lock icon */}
      <div style={{
        width: 64, height: 64, borderRadius: 18,
        background: 'var(--bg-card)', border: '1px solid var(--border)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: 'var(--accent)', marginBottom: 16,
      }}>
        <Lock size={32} />
      </div>

      <h1 style={{
        fontSize: 22, fontWeight: 700, color: 'var(--text-primary)',
        marginBottom: 8, lineHeight: 1.3,
      }}>
        Доступ закрыт
      </h1>

      <p style={{
        fontSize: 14, color: 'var(--text-secondary)', lineHeight: 1.5,
        marginBottom: 24, maxWidth: 320,
      }}>
        Оформите подписку, чтобы получить доступ к объектам, событиям, библиотеке и сообществу.
      </p>

      {/* Same plan cards + Stripe Payment Links (client_reference_id=telegram_id) as Onboarding.
          Строку «Остались вопросы?» прячем — на Paywall её заменяет блок кнопок ниже. */}
      <PlansSlide showContactLine={false} />

      {/* Блок для возвратного клиента: восстановить доступ / пересмотреть проект / написать менеджеру */}
      <p style={{
        fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.5,
        margin: '24px 0 12px', maxWidth: 360,
      }}>
        Если вы уже были нашим клиентом, вы можете:
      </p>

      {/* Secondary action: update payment method via Stripe Customer Portal */}
      <button
        onClick={handlePortal}
        disabled={portalLoading}
        style={{
          marginTop: 0,
          width: '100%',
          maxWidth: 360,
          background: 'transparent',
          border: '1px solid var(--border)',
          borderRadius: 12,
          padding: '13px 16px',
          fontSize: 14,
          fontWeight: 600,
          color: portalLoading ? 'var(--text-secondary)' : 'var(--text-primary)',
          cursor: portalLoading ? 'default' : 'pointer',
          opacity: portalLoading ? 0.6 : 1,
        }}
      >
        {portalLoading ? 'Загрузка…' : 'Обновить оплату'}
      </button>

      {/* Ознакомиться с проектом заново — перезапуск воронки с самого начала (replay) */}
      <button
        onClick={() => { if (onReplayOnboarding) onReplayOnboarding(); }}
        style={{
          marginTop: 10,
          width: '100%',
          maxWidth: 360,
          background: 'transparent',
          border: '1px solid var(--border)',
          borderRadius: 12,
          padding: '13px 16px',
          fontSize: 14,
          fontWeight: 600,
          color: 'var(--text-primary)',
          cursor: 'pointer',
        }}
      >
        Ознакомиться с проектом с начала
      </button>

      {/* Secondary action: open manager chat in Telegram */}
      <button
        onClick={() => {
          const url = 'https://t.me/rusnacartem';
          const tg = window.Telegram?.WebApp;
          if (tg?.openTelegramLink) {
            tg.openTelegramLink(url);
          } else if (tg?.openLink) {
            tg.openLink(url);
          } else {
            window.open(url, '_blank');
          }
        }}
        style={{
          marginTop: 10,
          width: '100%',
          maxWidth: 360,
          background: 'transparent',
          border: '1px solid var(--border)',
          borderRadius: 12,
          padding: '13px 16px',
          fontSize: 14,
          fontWeight: 600,
          color: 'var(--text-primary)',
          cursor: 'pointer',
        }}
      >
        Связаться с менеджером
      </button>
    </div>
  );
}
